<template>
    <v-avatar
        :class="[
            'client-avatar',
            inverted ? color + '-invert' : color,
            clickable ? 'clickable' : ''
        ]"
        :size="large ? 80 : size"
        tile
    >
        <span
            :class="[
                inverted ? color + '--text' : 'white--text',
                large ? 'display-1 font-weight-regular' : `${text_class} font-weight-bold`
            ]"
        >
            {{ initials }}
        </span>
    </v-avatar>
</template>

<script>
import { computed } from "@vue/composition-api";

export default {
    name: "ClientAvatar",
    props: {
        color: {
            type: String,
            required: true
        },
        initials: {
            type: String,
            required: true
        },
        inverted: {
            type: Boolean,
            default: false
        },
        size: {
            type: Number,
            default: 32
        },
        large: {
            type: Boolean,
            default: false
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const text_class = computed(function() {
            return props.initials != null && props.initials.length > 2 ? "caption" : "body-2";
        });
        return {
            text_class
        };
    }
};
</script>
